var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._l((_vm.jobs),function(item,index){return [_vm._v(_vm._s(item.Name)+_vm._s(index+1==_vm.jobs.length? '':', '))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }